import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import BedbankDetailsSection from './BedbankDetailsSection'

import FoldableContent from 'components/Common/FoldableContent/FoldableContent'
import { BaseImage } from 'components/Common/OrderView/styles'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`

interface Prop {
  offer: App.BedbankOffer
  pkg: App.BedbankPackage
}

function PlannedBedbankOfferPackageSummary({ offer, pkg }: Prop) {
  const intl = useIntl()

  const yourPackageHeading = intl.formatMessage({
    id: 'NOpkyER+6r',
    defaultMessage: 'Your Package',
    description: 'Heading for the planned bedbank accommodation package summary section',
  })

  const hideDetailsLabel = intl.formatMessage({
    id: 'WROTB4yfWN',
    defaultMessage: 'Hide package and room details',
    description: 'Button text to collapse the package and room details section',
  })

  const viewDetailsLabel = intl.formatMessage({
    id: 'hshw9v+0r9',
    defaultMessage: 'View package and room details',
    description: 'Button text to expand the package and room details section',
  })

  const imageId = pkg.images[0]?.id || offer.image.id
  return (
    <BookingDetails>
      <Heading variant="heading5">{yourPackageHeading}</Heading>
      {imageId && (
        <BaseImage
          className="hidden-print"
          id={imageId}
          mobileAspectRatio="9:4"
          mobileWidth="100"
        />
      )}
      <BodyText variant="medium" weight="bold">
        {pkg.name}
      </BodyText>
      <FoldableContent
        openLabel={hideDetailsLabel}
        closedLabel={viewDetailsLabel}
      >
        <BedbankDetailsSection pkg={pkg} />
      </FoldableContent>
    </BookingDetails>
  )
}

export default PlannedBedbankOfferPackageSummary
